import React, { useEffect, useRef, useState } from 'react';
import useEmblaCarousel from 'embla-carousel-react';
import { handlise } from '../../helpers/urlHelpers';
const VariantImageCarousel = ({ product, productImages, dynamicData, productHandle, baseProductIndex, componentIndex, productIndex, showCustomiserImage, isActive, modalOpen, selectPartColor }) => {
    const [selectedVariant, setSelectedVariant] = useState(null);
    const lastTriggeredVariantRef = useRef(null);
    useEffect(() => {
        if (dynamicData && productImages) {
            const newSelectedIndex = dynamicData.findIndex((variant) => variant.selected);
            const newSelected = productImages[newSelectedIndex];
            if (newSelected) {
                setSelectedVariant(newSelected);
            }
        }
    }, [productImages, dynamicData]);
    const [emblaRef, emblaApi] = useEmblaCarousel({ loop: true });
    const slidesRef = useRef([]);
    // Limit Images -- Only Show 1 Image from each Colour / Color
    const [colourOptions, setColourOptions] = useState([]);
    const [colourOptionImages, setColourOptionImages] = useState([]);
    const [limitImagesToColours, setLimitImagesToColours] = useState(false);
    useEffect(() => {
        if (!emblaApi || !selectedVariant || !isActive)
            return;
        if (limitImagesToColours) {
            const targetIndex = colourOptionImages.findIndex((v) => v.variant_options[0] === selectedVariant.variant_options[0]);
            if (targetIndex !== -1) {
                setTimeout(() => {
                    emblaApi.scrollTo(targetIndex, true);
                    lastTriggeredVariantRef.current = selectedVariant.title;
                }, 1);
            }
        }
        else {
            const targetIndex = productImages.findIndex((v) => v.id === selectedVariant.id);
            if (targetIndex !== -1) {
                emblaApi.scrollTo(targetIndex, true);
                lastTriggeredVariantRef.current = selectedVariant.title;
            }
        }
    }, [selectedVariant, emblaApi, isActive, limitImagesToColours]);
    useEffect(() => {
        if (emblaApi && isActive) {
            const onSettle = () => {
                const selectedIndex = emblaApi.selectedScrollSnap();
                const selectedSlide = slidesRef.current[selectedIndex];
                if (!selectedSlide)
                    return;
                const variantValue = selectedSlide.getAttribute('data-variant-value');
                if (!variantValue)
                    return;
                const matchedIndex = productImages.findIndex((v) => String(v.id) === variantValue);
                const matchedVariant = productImages[matchedIndex];
                const matchedData = dynamicData[matchedIndex];
                if (!modalOpen || !matchedData || !matchedVariant)
                    return;
                const alreadySelected = matchedData.selected;
                const wasJustSelected = lastTriggeredVariantRef.current === matchedVariant.title;
                if (alreadySelected || wasJustSelected)
                    return;
                lastTriggeredVariantRef.current = matchedVariant.title;
                selectPartColor(baseProductIndex, matchedData.compIndex, matchedData.prodIndex, matchedVariant.title);
            };
            emblaApi.on('settle', onSettle);
            return () => {
                emblaApi.off('settle', onSettle);
            };
        }
    }, [emblaApi, isActive, modalOpen]);
    const handleSlideClick = (variant, index) => {
        lastTriggeredVariantRef.current = variant.title;
        selectPartColor(baseProductIndex, componentIndex, productIndex, variant.title);
        emblaApi === null || emblaApi === void 0 ? void 0 : emblaApi.scrollTo(index);
    };
    // Limit Images -- Only Show 1 Image from each Colour / Color
    useEffect(() => {
        if (product && product.product_options.length > 1) {
            const colourOptionIndex = Math.max(product.product_options.indexOf('Colour'), product.product_options.indexOf('Color'));
            if (colourOptionIndex !== -1) {
                setLimitImagesToColours(true);
                const swatchesMap = new Map();
                product.variants.forEach((variant) => {
                    const colourOption = variant.variant_options[colourOptionIndex];
                    if (colourOption && !swatchesMap.has(colourOption)) {
                        swatchesMap.set(colourOption, colourOption);
                    }
                });
                setColourOptions(Array.from(swatchesMap.values()));
            }
        }
    }, [product]);
    useEffect(() => {
        const newImages = [];
        colourOptions.forEach((colourOption) => {
            const matchingSwatch = productImages.find((swatch) => swatch.variant_options.includes(colourOption));
            if (matchingSwatch) {
                newImages.push(matchingSwatch);
            }
        });
        setColourOptionImages(newImages);
    }, [colourOptions, productImages]);
    if (!selectedVariant || !productImages)
        return null;
    return (React.createElement("div", { "data-variant-carousel-wrapper": true },
        React.createElement("div", { className: `variants-image-carousel order order--${productImages[0].component} ${productHandle} ${isActive ? 'active' : 'hide'}` },
            React.createElement("div", { className: "variants-image-carousel__wrapper embla" },
                React.createElement("div", { className: "embla__viewport", ref: emblaRef },
                    React.createElement("div", { className: "embla__container" }, limitImagesToColours
                        ? colourOptionImages.map((swatch, index) => (React.createElement("div", { key: index, onClick: () => handleSlideClick(swatch, index), ref: (el) => (slidesRef.current[index] = el), "data-variant-value": swatch.id, className: `embla__slide${selectedVariant.id === swatch.id ? ' selected' : ''}${!swatch.available ? ' oos' : ''}` },
                            React.createElement("div", null,
                                React.createElement("div", { className: `type type--${swatch.component}` },
                                    React.createElement("img", { className: "img img--mode-light", src: showCustomiserImage ? swatch.customiser_image : swatch.featured_image }),
                                    swatch.dark_mode_image && (React.createElement("img", { className: "img img--mode-dark", src: swatch.dark_mode_image })))))))
                        : productImages.map((swatch, index) => (React.createElement("div", { key: index, onClick: () => handleSlideClick(swatch, index), ref: (el) => (slidesRef.current[index] = el), "data-variant-value": swatch.id, className: `embla__slide${selectedVariant.id === swatch.id ? ' selected' : ''}${!swatch.available ? ' oos' : ''}` },
                            React.createElement("div", null,
                                React.createElement("div", { className: `type type--${swatch.component}` },
                                    React.createElement("img", { className: "img img--mode-light", src: showCustomiserImage ? swatch.customiser_image : swatch.featured_image }),
                                    swatch.dark_mode_image && (React.createElement("img", { className: "img img--mode-dark", src: swatch.dark_mode_image })),
                                    dynamicData[index].monogramming && dynamicData[index].monogramming.length ? (React.createElement("svg", { className: `fg-cust__dynamic-image--monogram${dynamicData[index].emojis && dynamicData[index].emojis.length ? ' has-emoji' : ''} monogram-placement--${handlise(dynamicData[index].placement)}`, xmlns: "http://www.w3.org/2000/svg", version: "1.1", viewBox: "0 0 211 6", fill: "none" },
                                        React.createElement("path", { id: "curve", d: "M0.902344 1C15.5221 3 42.5802 7.02724 107.893 6.9999C173.207 6.97255 199.483 3 211.902 1" }),
                                        React.createElement("text", { dominantBaseline: "middle" },
                                            React.createElement("textPath", { xlinkHref: "#curve", alignmentBaseline: "middle", startOffset: "50%", textAnchor: "middle" }, dynamicData[index].monogramming)))) : null,
                                    dynamicData[index].monogramming_back && dynamicData[index].monogramming_back.length ? (React.createElement("div", { className: "fg-cust__dynamic-image--monogram-back" },
                                        dynamicData[index].additional_image != '' ? (React.createElement("img", { src: dynamicData[index].additional_image, height: 500, width: 400 })) : null,
                                        React.createElement("svg", { className: "fg-cust__dynamic-image--monogram-back", xmlns: "http://www.w3.org/2000/svg", width: "212", height: "2", viewBox: "0 0 212 2", fill: "none" },
                                            React.createElement("path", { d: "M0.65625 0.811334L212.234 0.811316", id: "monogram-back-line" }),
                                            React.createElement("text", null,
                                                React.createElement("textPath", { xlinkHref: "#monogram-back-line", 
                                                    // @ts-ignore
                                                    alignmentBaseline: "bottom", startOffset: "50%", textAnchor: "middle" }, dynamicData[index].monogramming_back))))) : null,
                                    dynamicData[index].emojis ? (React.createElement("div", { className: `fg-cust__dynamic-image--emojis emojis-placement--${handlise(dynamicData[index].placement)}${dynamicData[index].monogramming && dynamicData[index].monogramming.length ? ' has-monogramming' : ''}` }, dynamicData[index].emojis
                                        .sort((a, b) => a.timestamp - b.timestamp)
                                        .map((emoji) => (React.createElement("div", { key: emoji.name, className: `emoji`, dangerouslySetInnerHTML: { __html: emoji.svg_code } }))))) : null))))))))),
        React.createElement("div", { className: `variants-image-controls ${isActive ? 'active' : 'hide'}` },
            React.createElement("button", { className: "embla__button embla__button--prev", "aria-label": "Previous slide", onClick: () => emblaApi === null || emblaApi === void 0 ? void 0 : emblaApi.scrollPrev(), disabled: !emblaApi },
                React.createElement("svg", { width: "52", height: "52", viewBox: "0 0 52 52", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                    React.createElement("circle", { cx: "26", cy: "26", r: "26", transform: "rotate(180 26 26)", fill: "#eaeaea" }),
                    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M28.8261 34L21 26L28.8261 18L30 19.2L23.3478 26L30 32.8L28.8261 34Z", fill: "black" }))),
            React.createElement("button", { onClick: () => emblaApi === null || emblaApi === void 0 ? void 0 : emblaApi.scrollNext(), className: "embla__button embla__button--next", "aria-label": "Next slide", disabled: !emblaApi },
                React.createElement("svg", { width: "52", height: "52", viewBox: "0 0 52 52", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                    React.createElement("circle", { cx: "26", cy: "26", r: "26", fill: "#eaeaea" }),
                    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M23.1739 18L31 26L23.1739 34L22 32.8L28.6522 26L22 19.2L23.1739 18Z", fill: "black", fillOpacity: "0.8" }))))));
};
export default VariantImageCarousel;
